export default "__VITE_ASSET__DRHlWqGg__"